import React from 'react';
import PropTypes from 'prop-types';
import getRoute, { getRouteOptions } from '../../utils';

class Router extends React.Component {
  constructor(props) {
    super();
    this.config = getRouteOptions(props.config);
  }

  render() {
    const { pathname, search, hash, children = null } = this.props;
    const config = this.config;

    if (!pathname) {
      return children;
    }

    const { Component, currentLocation } = getRoute({ pathname, config, search, hash });
    const componentProps = currentLocation ? { currentLocation } : {};

    return <Component {...componentProps} />;
  }
}

Router.propTypes = {
  config: PropTypes.object.isRequired,
  pathname: PropTypes.string,
  search: PropTypes.string,
  hash: PropTypes.string,
  children: PropTypes.object,
};

export default Router;

